import type { FormOption } from '@/screens/ReportCreation/reportCreation.types';
import type { TFunction } from 'i18next';
import { SupportedLanguage } from '@store/i18n';

type ToggleOptionConfig = {
  value: string;
  labelKey: string;
};

export const buildToggleOptions = (
  t: TFunction,
  optionsConfig: ToggleOptionConfig[],
  language?: SupportedLanguage,
): FormOption[] =>
  optionsConfig.map(({ value, labelKey }) => ({
    value,
    label: t(labelKey, { lng: language }),
  }));
